import {Controller} from '@hotwired/stimulus';


/* stimulusFetch: 'lazy' */
export default class extends Controller {

    static targets = ['commentModal', 'replyModal', 'disclaimer', 'lastCommentId', 'scrollTopButton'];
    static values = {
        url: String,
        replyModalUrl: String
    }

    rendered = false;

    async connect() {
        this.commentModalTarget.removeAttribute("hidden");
        await this.openModalForSingleCommentFromQuerystring()
    }

    async openModal() {

        document.body.classList.add('overflow-hidden');
        this.commentModalTarget.classList.add('pointer-events-auto');
        this.commentModalTarget.classList.remove('translate-x-full');

        if (this.rendered) {
            return;
        }

        this.commentModalTarget.insertAdjacentHTML('beforeend', new Array(20).join(`<i class="block my-4 rounded bg-color-3 animate-pulse min-h-5 w-full"></i>`))

        const response = await fetch(`${this.urlValue}`);
        this.commentModalTarget.innerHTML = '';
        this.commentModalTarget.insertAdjacentHTML('beforeend', await response.text())
        this.rendered = true;

       // const analyticsUrl = window.location.pathname.replace("/news/", "/comment/");

        /*
        *
        if (typeof ga !== "undefined") {
            ga('send', {
                'hitType': 'pageview',
                'page': analyticsUrl
            });

            ga('reportglobale.send', {
                'hitType': 'pageview',
                'page': analyticsUrl
            });
        }
        */
    }

    async openModalForSingleComment() {
        // add to the same controller element a dataset with single comment id (possibly used by render-comments)
        this.element.dataset.commentId = this.lastCommentIdTarget.dataset.commentId;
        await this.openModal();
    }

    async openModalForSingleCommentFromQuerystring() {
        const commentId = new URLSearchParams(window.location.search).get('commentId');
        if (!commentId) {
            return
        }
        // add to the same controller element a dataset with single comment id (possibly used by render-comments)
        this.element.dataset.commentId = commentId;
        await this.openModal();
    }


    closeModal() {
        document.body.classList.remove('overflow-hidden');
        this.commentModalTarget.classList.remove('pointer-events-auto')
        this.commentModalTarget.classList.add('translate-x-full')

        // deletes any single comment id
        delete this.element.dataset.commentId;
    }

    scrollTop() {

        if (this.hasCommentModalTarget) {

            this.commentModalTarget.scrollTo({
                top: 0,
                left: 0,
                behavior: "smooth",
            });
        }
    }
    showScrollTop() {

        this.scrollTopButtonTarget.classList.remove('opacity-0');
    }

    closeReplyModal() {
        this.replyModalTarget.classList.remove('translate-x-0')
        this.replyModalTarget.classList.add('translate-x-full')
        this.commentModalTarget.classList.remove('overflow-hidden')
        this.replyModalTarget.setAttribute("hidden", true)
        this.replyModalTarget.innerHTML = '';
    }

    showDisclaimer(e) {
        this.disclaimerTarget.removeAttribute('hidden')
    }

    async openReplyModal(e) {
        this.replyModalTarget.removeAttribute("hidden")
        this.replyModalTarget.insertAdjacentHTML('beforeend', new Array(50).join(`<i class="block my-4 rounded bg-color-3 animate-pulse min-h-5 w-full"></i>`))
        this.replyModalTarget.classList.add('translate-x-0')
        this.replyModalTarget.classList.remove('translate-x-full')
        this.commentModalTarget.classList.add('overflow-hidden')
        const params = new URLSearchParams({commentId: e.currentTarget.dataset.commentId});
        const response = await fetch(`${this.replyModalUrlValue}?${params.toString()}`);
        this.replyModalTarget.innerHTML = '';
        this.replyModalTarget.insertAdjacentHTML('beforeend', await response.text())
    }

}